export default {
  kvText: 'มหกรรมช้อปปิ้งเริ่มแล้ว!\nเตรียมพบกับดีลสุดคุ้ม!',
  countdown: {
    start: 'กิจกรรมจะเริ่มใน: {time}',
    end: 'กิจกรรมจะสิ้นสุดใน: {time}',
  },
  verify: {
    title: 'ยืนยันบัญชี',
    placeholder: 'กรุณากรอก ID บัญชีของคุณ',
    accountId: 'ID',
    accountName: 'ชื่อ',
    login: 'เข้าสู่ระบบ',
    confirm: 'กรุณาตรวจสอบข้อมูลบัญชีของคุณ',
    switchAccount: 'กรอกใหม่',
  },
  plaza: 'ศูนย์การค้า',
  desc: 'ไปที่หน้าเติมเงินออนไลน์ [{clickHere}] ทุกการเติม เพชรรุ้ง 100 เม็ด จะได้รับคูปองช้อปปิ้ง 1 ใบ ใช้คูปองช้อปปิ้งเพื่อซื้อรางวัลสุดคุ้มในศูนย์การค้า!',
  clickHere: 'คลิกที่นี่',
  eventTime: 'ระยะเวลากิจกรรม: 6 พ.ย. 2026 เวลา 00:00 ถึง 15 พ.ย. 2026 เวลา 23:59 (GMT+7)\nสิ้นสุดการรับรางวัลในวันที่ 22 พ.ย. 2026 เวลา 23:59 (GMT+7)',
  remaining: 'คูปองช้อปปิ้งคงเหลือ: {n}',
  remainingLabel: 'คูปองช้อปปิ้งคงเหลือ:',
  goods: {
    hotDeals: 'สินค้าสุดคุ้ม',
    dailyDeals: 'คุ้มค่าทุกวัน',
    viewDaily: 'สินค้าสุดคุ้มประจำวัน',
    price: 'คูปองช้อปปิ้ง {n} ใบ',
    purchase: 'ซื้อ',
    remainTimes: 'จำนวนครั้งในการซื้อที่เหลือ: {n}',
    notEnoughVoucher: 'คูปองช้อปปิ้งไม่เพียงพอ',
    soldOut: 'สินค้าหมด',
    max: 'MAX',
    confirm: 'คุณแน่ใจหรือไม่ว่าต้องการใช้คูปองช้อปปิ้ง {n} ใบ เพื่อซื้อ {name}?',
    success: 'ซื้อสำเร็จ โปรดเข้าสู่ระบบเกมและตรวจสอบกล่องจดหมายในเกม',
    history: 'ประวัติการซื้อ',
    spent: 'คูปองช้อปปิ้งที่ใช้ไป',
    details: 'รายละเอียดการซื้อ',
    time: 'เวลาที่ซื้อ',
    expired: 'ไอเทมที่คุณเลือกหมดอายุแล้ว โปรดรีเฟรชหน้าและเลือกใหม่อีกครั้ง',
    notEnoughDesc: 'คูปองช้อปปิ้งของคุณไม่เพียงพอ เติม เพชรรุ้ง เพื่อรับคูปองช้อปปิ้งเพิ่มเติม',
  },
  milestone: {
    allAchieved: 'คุณสามารถรับรางวัลทั้งหมดได้',
    subtitle: 'ใช้คูปองช้อปปิ้งสะสมให้ถึงเป้าหมายเพื่อรับหีบ หีบสมบัติสุดหรู!',
    topUp: 'เติมเงินเลย',
    history: 'ประวัติการรับรางวัล',
    claimAll: 'รับทั้งหมด',
    nextTip: 'ใช้คูปองช้อปปิ้งเพิ่มอีก {n} ใบ เพื่อรับรางวัลถัดไป',
    obtained: 'ได้รับแล้ว',
    claimable: 'รับได้',
    notAchieved: 'ยังไม่สำเร็จ',
    spend: 'ใช้คูปองช้อปปิ้ง {n} ใบ',
    header: 'รางวัลตามเป้าหมาย',
    rewardDetails: 'รายละเอียดรางวัล',
    claimTime: 'เวลาที่รับ',
    claimSuccess: 'รับรางวัลสำเร็จ!',
    claimAllSuccessDesc: 'รับรางวัลที่พร้อมรับทั้งหมดสำเร็จ!\nดูรายละเอียดได้ที่ {history}',
    claimSuccessDesc: 'รับไอเทมสำเร็จ! คุณสามารถเข้าสู่ระบบเกมเพื่อรับรางวัลผ่านกล่องจดหมายในเกมได้!',
  },
  common: {
    empty: 'ยังไม่มีประวัติ',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
  },
  rule: {
    title: 'กฎของกิจกรรม',
    content: [
      '1. ในระหว่างกิจกรรม เติมเพชรรุ้งผ่านศูนย์เติมเงินอย่างเป็นทางการ เพื่อรับคูปองช้อปปิ้ง โดยทุกการเติมเพชรรุ้ง 100 เพชร จะได้รับคูปองช้อปปิ้ง 1 ใบ',
      '2. ใช้คูปองช้อปปิ้งที่ ช้อปปิ้งพลาซ่า เพื่อแลกรับไอเทมต่าง ๆ รวมถึงกรอบอวาตาร์พิเศษเฉพาะกิจกรรม ช็อปปิ้งมือโปร\n คุณสามารถรับ [ดีลประจำวัน] ซึ่งเป็นรางวัลสุดคุ้มได้ด้วยคูปองช้อปปิ้งเพียง 1 ใบ โดยรายการรางวัลจะรีเฟรชทุกวันเวลา 00:00 น. (GMT+7)',
      '3. การใช้คูปองช้อปปิ้งจะช่วยเพิ่มความคืบหน้าในการช้อปปิ้ง เมื่อถึงระดับที่กำหนด คุณจะสามารถรับหีบรางวัล หีบสุดแรร์ ที่ตรงกับระดับนั้นได้',
      '4. หลังจากกิจกรรมสิ้นสุดลง คูปองช้อปปิ้งที่ยังไม่ได้ใช้จะหมดอายุ ดังนั้นโปรดใช้ให้ทันเวลา ส่วนรางวัล ระดับสุดยอด ที่ยังไม่ได้รับจะถูกส่งให้คุณโดยอัตโนมัติผ่านจดหมายภายในเกม',
      '5. โปรดเข้าร่วมกิจกรรมผ่านช่องทางการชำระเงินของบุคคลที่สามที่กำหนดอย่างเป็นทางการเท่านั้น การตรวจสอบสิทธิ์และรางวัลที่เกี่ยวข้องกับรายการคืนเงิน คำสั่งซื้อที่ผิดปกติ หรือการละเมิดกฎ จะดำเนินการตามกฎของกิจกรรม',
      '6. หากมีข้อสงสัย โปรดติดต่อเราผ่านปุ่ม ฝ่ายบริการลูกค้า บนหน้านี้ หรือช่องทางฝ่ายบริการลูกค้าภายในเกม',
    ].join('\n\n'),
  },
  status: {
    notStart: 'กิจกรรมยังไม่เริ่ม',
    ended: 'กิจกรรมจบแล้ว',
  },
}
